import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';

import css from './MobileApps.module.scss';

const MobileApps = () => {
	const images = useStaticQuery(IMAGES_QUERY);
	return (
		<section className={css.mobileApps}>
			<h2 data-aos="custom-fade-right">Manage your Investments on the go</h2>
			<h4 data-aos="custom-fade-right">
				Fast, financial facilities available to you anytime, anywhere.
			</h4>
			<p data-aos="custom-fade-right">
				Transact seamlessly, switching between our app and website.
			</p>
			<div className={css.appLinks} data-aos="custom-fade-right">
				<img
					src="/images/home/play-store.png"
					alt="moneyfront app on playstore"
					loading="lazy"
				/>
				<img
					src="/images/home/ios-store.png"
					alt="moneyfront app on ios store"
					loading="lazy"
				/>
				{/* <Img
					fixed={images.playStore.childImageSharp.fixed}
					alt="moneyfront app on playstore"
				/>
				<Img
					fixed={images.iosStore.childImageSharp.fixed}
					alt="moneyfront app on ios store"
				/> */}
			</div>
			<div className={css.mobileAppsImg} data-aos="custom-fade-left">
				<Img
					fluid={images.appMockup.childImageSharp.fluid}
					alt="moneyfront app"
				/>
			</div>
		</section>
	);
};

const IMAGES_QUERY = graphql`
	{
		appMockup: file(relativePath: { eq: "home/app-mockup.png" }) {
			childImageSharp {
				fluid {
					...GatsbyImageSharpFluid_withWebp_noBase64
				}
			}
		}
		playStore: file(relativePath: { eq: "home/play-store.png" }) {
			childImageSharp {
				fixed(height: 48) {
					...GatsbyImageSharpFixed_withWebp_noBase64
				}
			}
		}
		iosStore: file(relativePath: { eq: "home/ios-store.png" }) {
			childImageSharp {
				fixed(height: 48) {
					...GatsbyImageSharpFixed_withWebp_noBase64
				}
			}
		}
	}
`;

export default MobileApps;
